<template>
  <div id="app">
    <headers></headers>
    <div class="read-over">
      <div class="w_1400">
        <div class="previous-page">
          <a @click="$router.push({name:'homework'})"><i class="el-icon-arrow-left" style="color: #fff;font-size: 30px;"></i></a>
        </div>
        <!-- 判断是否已批改，未批改模块 -->
        <div class="read-over-one" v-if="wayList.audit==1">
          <!-- 作业标题 -->
          <h1>{{wayList.title}}</h1>
          <p>本次作业共{{wayList.total_score}}分。{{wayList.pass_score}}分及格。共{{wayList.paper.length}}小题。</p>
          <!-- 循环展示题型 -->
          <ul v-if="classList">
            <li v-for="item in classList">{{item}}</li>
          </ul>
        </div>
        <!-- 判断是否已批改，已批改模块 -->
        <div class="read-over-three" v-else-if="wayList.audit==2">
          <div class="read-over-three-left">
            <div class="read-over-three-tit">
              <!-- 作业标题 -->
              {{wayList.paper.title}}
              <!-- 判断成绩是否合格 -->
              <el-tag style="float: right;" :type="totalscore()>wayList.pass_score?'success':'warning'">
                {{totalscore()>wayList.pass_score?'考试合格':'成绩不合格'}}</el-tag>
            </div>
            <div class="read-over-three-txt">
              <span>答题人：{{wayList.nickname}}</span>
              <span>交卷时间：{{timestampToTime(wayList.createtime)}}</span>
            </div>
          </div>
          <div class="read-over-three-right">
            <div>
              <p>{{totalscore()}}</p>
              <p>总分:<span>{{wayList.total_score}}</span></p>
            </div>
          </div>
        </div>

        <div class="read-over-two" v-if="wayList.paper">
          <form action="">
            <div class="read-over-list" v-if="wayList">
              <div v-for="(item,index) in wayList.paper">
                <!-- 单选题或判断题展示模块 -->
                <div class="stem type-one" v-if="item.question.type==0||item.question.type==2">
                  <!-- 生成默认id -->
                  <div class="item" :id="'ibs-'+index">
                    <div class="editor-tit">
                      <h3>
                        <span v-if="item.question.type==0">单选题</span>
                        <span v-else>判断题</span>
                        <span>{{index+1}}</span>
                        {{item.question.title}}({{item.score}}分)
                      </h3>
                      <!-- 循环题目选项 -->
                      <p v-for="(res,key) in item.question.options_json" :class="item[key]">{{key}}.{{res}}</p>
                    </div>

                    <div class="editor-txt">
                      正确答案：<span class="editor-txt-success">{{item.question.answer}}</span>, 你的答案：<span
                        class="editor-txt-danger">{{wayList.user_answer[index].answer}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                      <font v-if="item.question.answer!==wayList.user_answer[index].answer">回答错误</font>
                      <font v-else>回答正确</font>
                    </div>
                  </div>

                </div>
                <!-- 多选题展示模块 -->
                <div class="stem type-two" v-else-if="item.question.type==1">
                  <div class="item" :id="'ibs-'+index">
                    <div class="editor-tit">
                      <h3>
                        <span>多选题</span>
                        <span>{{index+1}}</span>
                        {{item.question.title}}({{item.score}}分)
                      </h3>

                      <p v-for="(res,key) in item.question.options_json" :class="item[key]">{{key}}.{{res}}</p>
                    </div>

                    <div class="editor-txt">
                      正确答案：<span class="editor-txt-success">{{item.question.answer}}</span>, 你的答案：<span
                        class="editor-txt-danger">{{wayList.user_answer[index].answer}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                      <font v-if="answerft(item.question.answer,wayList.user_answer[index].answer)">回答错误</font>
                      <font v-else>回答正确</font>
                    </div>
                  </div>
                </div>
                <!-- 填空题,简答题展示模块 -->
                <div class="stem type-three" v-else-if="item.question.type==3">
                  <div class="item" :id="'ibs-'+index">
                    <div class="editor-tit">
                      <h3>
                        <span>简答题</span>
                        <span>{{index+1}}</span>
                        {{item.question.title}}({{item.score}}分)
                      </h3>

                      <p>{{wayList.user_answer[index].answer}}</p>
                    </div>

                    <div class="editor-txt">
                      <h4>正确答案</h4>
                      <p>{{item.question.answer}}</p>
                    </div>

                    <div class="editor-fraction" v-if="wayList['user_answer'][index]">
                      <span>请为该答案打分:</span>

                      <!-- <el-input-number v-if="wayList.user_answer[index]"
                        v-model="wayList.user_answer[index].score" @change="handleChange(index)" :min="1" :max="10"
                        label="描述文字"></el-input-number> -->
                        <el-input-number v-model="wayList['user_answer'][index]['score']" controls-position="right" @change="handleChange" :min="0" :max="item.score"></el-input-number>
                    </div>
                  </div>
                </div>
                <!-- 填空题,简答题展示模块 -->
                <div class="stem type-four" v-else-if="item.question.type==4">
                  <div class="item" :id="'ibs-'+index">
                    <div class="editor-tit">
                      <h3>
                        <span>拍照题</span>
                        <span>{{index+1}}</span>
                        {{item.question.title}}({{item.score}}分)
                      </h3>

                      <div class="viewer" id="viewer">
                        <p>
                            <el-image
                                style="width: 100px; height: 100px"
                                :src="wayList.user_answer[index].answer"
                                :preview-src-list="imglist">
                              </el-image>
                        </p>

                      </div>
                    </div>

                    <div class="editor-txt">
                      <h4>正确答案</h4>
                      <p>{{item.question.answer}}</p>
                    </div>

                    <div class="editor-fraction" v-if="wayList['user_answer'][index]">
                      <span>请为该答案打分:</span>

                      <!-- <el-input-number v-if="wayList.user_answer[index]"
                        v-model="wayList.user_answer[index].score" @change="handleChange(index)" :min="1" :max="10"
                        label="描述文字"></el-input-number> -->
                        <el-input-number v-model="wayList['user_answer'][index]['score']" controls-position="right" @change="handleChange" :min="0" :max="item.score"></el-input-number>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="stem type-five">
                <div class="item" id="ibs-5">
                  <div class="editor-tit">
                    <h3>
                      <span>视频题</span>
                      <span>06</span>
                      如何理解人的本质？(10分)
                    </h3>

                    <ul>
                      <li>
                        <a href="JavaScript:;" data-src="images/5sjfx.mp4"></a>
                      </li>
                    </ul>
                  </div>

                  <div class="editor-txt">
                    <h4>正确答案</h4>
                    <p>因为正确的人生观能指导人生不走错路，少走弯路。 每个人的人生都需要有一个人生观，这样才能活出有价值的人生，正确的人生观是需要我们一边走自己的人生路，一边思考探索一遍摸索着前行。
                      人生的人生观来自于我们对于自己的人生的幸福和苦乐的感受，这决定我们的一生。</p>
                  </div>

                  <div class="editor-fraction">
                    <span>请为该答案打分:</span>
                    <input type="number" oninput="if(value>10)value=10;if(value<0)value=0">
                  </div>
                </div>
              </div> -->
              <!-- 总得分,未批改时展示 -->
              <div class="stem type-button" v-if="wayList.audit==1">
                <span>得分数：{{totalscore()}} </span>
                <button type="button" class="type-but">取 消</button>
                <button type="button" class="type-but type-btn-primary" @click="dialogVisible=true">完成批阅</button>
              </div>
            </div>
            <div class="read-over-card">
              <div class="read-card-head">
                答题卡
              </div>
              <div class="read-card-body">
                <!-- 判断题型列表是否有单选题 -->
                <div class="item" v-if="classList.indexOf('单选题')!=-1">
                  <p>单选题</p>
                  <div class="read-anchor-link">
                    <!-- 循环所有题目,判断类型为0的题目展示 -->
                    <a v-for="(item,index) in wayList.paper" :href="'#ibs-'+index" v-if="item.question.type==0"
                      :class="item.question.answer!==wayList.user_answer[index].answer?'card-body-tag--danger':'card-body-tag--success'">{{index+1}}</a>
                  </div>
                </div>
                <div class="item" v-if="classList.indexOf('判断题')!=-1">
                  <p>判断题</p>
                  <div class="read-anchor-link">
                    <a v-for="(item,index) in wayList.paper" :href="'#ibs-'+index" v-if="item.question.type==2"
                      :class="item.question.answer!==wayList.user_answer[index].answer?'card-body-tag--danger':'card-body-tag--success'">{{index+1}}</a>
                  </div>
                </div>
                <div class="item" v-if="classList.indexOf('多选题')!=-1">
                  <p>多选题</p>
                  <div class="read-anchor-link">
                    <a v-for="(item,index) in wayList.paper" :href="'#ibs-'+index" v-if="item.question.type==1"
                      :class="answerft(item.question.answer,wayList.user_answer[index].answer)?'card-body-tag--danger':'card-body-tag--success'">{{index+1}}</a>
                  </div>
                </div>
                <div class="item" v-if="classList.indexOf('简答题')!=-1">
                  <p>简答题</p>
                  <div class="read-anchor-link">
                    <a v-for="(item,index) in wayList.paper" :href="'#ibs-'+index"
                      v-if="item.question.type==3">{{index+1}}</a>
                  </div>
                </div>
                <div class="item" v-if="classList.indexOf('拍照题')!=-1">
                  <p>拍照题</p>
                  <div class="read-anchor-link">
                    <a v-for="(item,index) in wayList.paper" :href="'#ibs-'+index"
                      v-if="item.question.type==4">{{index+1}}</a>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <el-dialog title="" :visible.sync="dialogVisible" width="30%" :before-close="handleCloses">
            <el-image
                style="width: 60px; height: 60px;font-size: 22.5px;"
                :src="url">
              </el-image>
              <h4 style="margin: 25px 0 10px 0;">提交批阅</h4>
              <span>确定都批改完成了吗</span>
            <span slot="footer" class="dialog-footer">
              <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
              <el-button  @click="dialogVisible = false">再看看</el-button>
              <el-button type="success" @click="open()">是 的</el-button>
              <!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
    <!-- <footers></footers> -->

  </div>
</template>

<script>
  import headers from '../../components/headers.vue';
  import footers from '../../components/footers.vue';
  import {
    paperDetails,
    submitPaperReview,
    practicepaperdet,
    prasub
  } from '../../request/api';

  export default {
    name: 'app',
    components: {
      headers,
      footers
    },
    computed: {

    },
    data() {
      return {
        wayList: '',
        nums: 1,
        id: '',
        paper_id: '',
        classList: [],
        dialogVisible: false,
        url:require('../../assets/images/success.png'),
        imglist:[]
      }
    },
    methods: {
      //判断多选题答案是否正确
      answerft(itemAnswer,userAnswer) {
        if (itemAnswer.toString().length !== itemAnswer.toString().length){
          return true;
        }
        return itemAnswer.toString().split(',').sort().join()!==userAnswer.toString().split(',').sort().join();
      },
      // 打开放大图片
      openmedia(url) {
        let abc =
          `<iframe id="inlineFrameExample"
            title="Inline Frame Example"
            src="` + url + `">
        </iframe>`
        this.$alert(abc, 'HTML 片段', {
          dangerouslyUseHTMLString: true
        });
      },
      // 批改提交弹窗
      open() {
        this.dialogVisible=false
        this.submitPaperReviews()
      },
      handleCloses(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            this.dialogVisible=false
          })
          .catch(_ => {});
      },
      // 计算得分方法
      totalscore() {
        if (this.wayList) {
          let num = 0;
          //循环所有题目
          this.wayList.paper.map((item, index) => {
            // 计算每题得分
            num += parseInt(this.wayList.user_answer[index].score)
          })
          //返回成绩
          return num;
        } else {
          return 0;
        }
      },
      //时间戳转日期格式
      timestampToTime(timestamp) {
        // 时间戳为10位需*1000，时间戳为13位不需乘1000
        var date = new Date(timestamp * 1000);
        var Y = date.getFullYear() + ".";
        var M =
          (date.getMonth() + 1 < 10 ?
            "0" + (date.getMonth() + 1) :
            date.getMonth() + 1) + ".";
        var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        var h = date.getHours() + ":";
        var m = date.getMinutes() + ":";
        var s = date.getSeconds();
        return Y + M + D;
      },
      // 加减主观题得分
      handleChange(currentValue) {
        // 获取原得分
        // console.log('sssss')
        // let num = this.wayList.user_answer[currentValue].answer
        // // 清空得分，再重新赋值，不然视图不刷新
        // this.wayList.user_answer[currentValue].answer = ''
        // this.wayList.user_answer[currentValue].answer = num
        this.$forceUpdate();
      },
      // 批阅提交
      async submitPaperReviews() {
        let self = true
        let daan = {}
        let teacher_id = JSON.parse(localStorage.getItem('userinfo')).teacher_id
        // 循环所有题目，使用同步接口，防止还没循环完成就提交
        await this.wayList.paper.map((res, index) => {
          //拿到所有题目id还有得分，重新赋值给一个对象
          let returndata = {
            question_id: res.question_id,
            score: this.wayList.user_answer[index].score
          }
          //追加到数组
          daan[index] = returndata
        })

        if (self) {
          let data = {
            paper_id: this.$route.query.paper_id ? this.$route.query.paper_id : '',
            user_id: this.$route.query.id ? this.$route.query.id : '',
            review: daan,
            teacher_id
          }
          if(this.ispra){
            await prasub(data).then(res => {
              if (res.code) {
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: 'success'
                });
                // this.$router.push({
                //   name: 'homework'
                // })
              } else {
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: 'error'
                });
              }
            })
          }else{
            await submitPaperReview(data).then(res => {
              if (res.code) {
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: 'success'
                });
                // this.$router.push({
                //   name: 'homework'
                // })
              } else {
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: 'error'
                });
              }
            })
          }
        }
      }
    },
    beforeCreate() {
      this.paper_id = this.$route.query.paper_id
      this.id = this.$route.query.id
      this.userinfo = JSON.parse(localStorage.getItem('userinfo'));
      this.ispra=!this.$route.query.type?false:true
      let self = this
      if(!this.$route.query.type){
        paperDetails({
          'paper_id': this.paper_id,
          'user_id': this.id,
        }).then(res => {
          // if (res.data.audit == 2) {
          //   this.$router.back(-1)
          // }
          this.wayList = res.data
          //循环所有题目
          this.wayList.paper.map((item, index) => {
            //判断本题是否有选项

            if (item.question.options_json) {
              //格式化选项为对象，方便循环
              item.question.options_json = JSON.parse(item.question.options_json)
              //判断用户是否提交了本题答案
              if (self.wayList.user_answer[index]) {
                // 默认给满分
                console.log(item.score)
                self.wayList.user_answer[index].score = item.score?item.score:0
                // 判断是否为单选题或判断题
                if (item.question.type == 0 || item.question.type == 2) {
                  //为用户答案添加样式（class），wrong为红色边框，exactness为绿色边框,
                  item[self.wayList.user_answer[index].answer] = 'wrong'
                  item[item.question.answer] = 'exactness'
                  //判断用户答案和题目正确答案是否不一致
                  if (self.wayList.user_answer[index].answer !== item.question.answer) {
                    // 不一致，得分为0
                    self.wayList.user_answer[index].score = 0
                  }
                } else if (item.question.type == 1) {
                  // 判断是否为多选题
                  // 分割正确答案为数组
                  // item.question.answer = item.question.answer.split(',')
                  // //分割用户答案为数组
                  // self.wayList.user_answer[index].answer = self.wayList.user_answer[index].answer.split(',')
                  // //循环正确答案的数组
                  // self.wayList.user_answer[index].answer.map(res => {
                  //   //判断用户答案的数组有没有正确答案的值，没有就赋wrong切本题得分设为0,有就赋exactness
                  //   if (item.question.answer.indexOf(res) != -1 ) {
                  //     item[res] = 'exactness'
                  //   } else {
                  //     item[res] = 'wrong'
                  //     self.wayList.user_answer[index].score = 0
                  //   }
                  // })
                  //此处false为正确，true为错误
                  if (this.answerft(item.question.answer,self.wayList.user_answer[index].answer) == false){
                    item[res] = 'exactness'
                  }else{
                        item[res] = 'wrong'
                        self.wayList.user_answer[index].score = 0
                  }
                }
              } else {
                // 学生未作答本题，为学生创建答案数组
                self.wayList.user_answer[index] = {
                  score: 0,
                  answer: ''
                }
                self.wayList.user_answer[index].score = 0
                self.wayList.user_answer[index].answer = ''
                // 判断是否为单选题获取判断题
                if (item.question.type == 0 || item.question.type == 2) {
                  // 默认给正确答案设置红色边框
                  item[item.question.answer] = 'exactness'
                } else if (item.question.type == 1) {
                  // 题目类型为多选题
                  // 分割正确答案为数组
                  item.question.answer = item.question.answer.split(',')
                  // 循环正确答案数组
                  item.question.answer.map(res => {
                    //给正确答案设置红色边框
                    item[res] = 'exactness'
                  })
                }
              }
            } else {
              // 题目类型为填空题，拍照题的
              // 判断用户是否提交了本题答案
              if (self.wayList.user_answer[index]) {
                // 有回答就默认本题满分
                self.wayList.user_answer[index].score = 0
              } else {
                // 没有回答就生成默认对象本题0分
                self.wayList.user_answer[index] = {}
                self.wayList.user_answer[index].score = 0
                self.wayList.user_answer[index].answer = ''
              }

              if(item.question.type == 4) {
                self.imglist.push(self.wayList.user_answer[index].answer)
              }
            }
            //判断所有题目题型，追加到题型列表
            switch (parseInt(item.question.type)) {
              case 0:
                if (this.classList.indexOf('单选题') == -1) {
                  this.classList.push('单选题')
                }
                return
              case 1:
                // this.classList.push('多选题')
                if (this.classList.indexOf('多选题') == -1) {
                  this.classList.push('多选题')
                }
                return
              case 2:
                // this.classList.push('判断题')
                if (this.classList.indexOf('判断题') == -1) {
                  this.classList.push('判断题')
                }
                return
              case 3:
                // this.classList.push('简答题')
                if (this.classList.indexOf('简答题') == -1) {
                  this.classList.push('简答题')
                }
                return
              case 4:
                // this.classList.push('拍照题')
                if (this.classList.indexOf('拍照题') == -1) {
                  this.classList.push('拍照题')
                }
                return
            }
          })
        })
      }else{
        practicepaperdet({
          'paper_id': this.paper_id,
          'user_id': this.id,
        }).then(res => {
          // if (res.data.audit == 2) {
          //   this.$router.back(-1)
          // }
          this.wayList = res.data
          //循环所有题目
          this.wayList.paper.map((item, index) => {
            //判断本题是否有选项
            console.log(item)
            if (item.question.options_json) {
              //格式化选项为对象，方便循环
              // console.log("sssssssssssssssss")
              item.question.options_json = JSON.parse(item.question.options_json)
              //判断用户是否提交了本题答案
              if (self.wayList.user_answer[index]) {
                // 默认给满分
                console.log(item.score)
                self.wayList.user_answer[index].score = item.score?item.score:0
                // 判断是否为单选题或判断题
                if (item.question.type == 0 || item.question.type == 2) {
                  //为用户答案添加样式（class），wrong为红色边框，exactness为绿色边框,
                  item[self.wayList.user_answer[index].answer] = 'wrong'
                  item[item.question.answer] = 'exactness'
                  //判断用户答案和题目正确答案是否不一致
                  if (self.wayList.user_answer[index].answer !== item.question.answer) {
                    // 不一致，得分为0
                    self.wayList.user_answer[index].score = 0
                  }
                } else if (item.question.type == 1) {
                  // 判断是否为多选题
                  // 分割正确答案为数组
                  item.question.answer = item.question.answer.split(',')
                  //分割用户答案为数组
                  self.wayList.user_answer[index].answer = self.wayList.user_answer[index].answer.split(',')
                  //循环正确答案的数组
                  item.question.answer.map(res => {
                    //判断用户答案的数组有没有正确答案的值，没有就赋wrong切本题得分设为0,有就赋exactness
                    if (self.wayList.user_answer[index].answer.indexOf(res) != -1) {
                      item[res] = 'exactness'
                    } else {
                      item[res] = 'wrong'
                      self.wayList.user_answer[index].score = 0
                    }
                  })
                }
              } else {
                // 学生未作答本题，为学生创建答案数组
                self.wayList.user_answer[index] = {
                  score: 0,
                  answer: ''
                }
                self.wayList.user_answer[index].score = 0
                self.wayList.user_answer[index].answer = ''
                // 判断是否为单选题获取判断题
                if (item.question.type == 0 || item.question.type == 2) {
                  // 默认给正确答案设置红色边框
                  item[item.question.answer] = 'exactness'
                } else if (item.question.type == 1) {
                  // 题目类型为多选题
                  // 分割正确答案为数组
                  item.question.answer = item.question.answer.split(',')
                  // 循环正确答案数组
                  item.question.answer.map(res => {
                    //给正确答案设置红色边框
                    item[res] = 'exactness'
                  })
                }
              }
            } else {
              // 题目类型为填空题，拍照题的
              // 判断用户是否提交了本题答案
              if (self.wayList.user_answer[index]) {
                // 有回答就默认本题满分
                self.wayList.user_answer[index].score = 0
              } else {
                // 没有回答就生成默认对象本题0分
                self.wayList.user_answer[index] = {}
                self.wayList.user_answer[index].score = 0
                self.wayList.user_answer[index].answer = ''
              }

              if(item.question.type == 4) {
                self.imglist.push(self.wayList.user_answer[index].answer)
              }
            }
            //判断所有题目题型，追加到题型列表
            switch (parseInt(item.question.type)) {
              case 0:
                if (this.classList.indexOf('单选题') == -1) {
                  this.classList.push('单选题')
                }
                return
              case 1:
                // this.classList.push('多选题')
                if (this.classList.indexOf('多选题') == -1) {
                  this.classList.push('多选题')
                }
                return
              case 2:
                // this.classList.push('判断题')
                if (this.classList.indexOf('判断题') == -1) {
                  this.classList.push('判断题')
                }
                return
              case 3:
                // this.classList.push('简答题')
                if (this.classList.indexOf('简答题') == -1) {
                  this.classList.push('简答题')
                }
                return
              case 4:
                // this.classList.push('拍照题')
                if (this.classList.indexOf('拍照题') == -1) {
                  this.classList.push('拍照题')
                }
                return
            }
          })
        })
      }
    }
  }
</script>

<style>
  @import url('../../assets/css/home.css');
  .dialog-footer{width: 100%;height: auto;overflow: hidden;display: inline-block;}
  .dialog-footer .el-button{width: 48%;float: left;}
  .el-dialog{width: 460px;}
</style>



// WEBPACK FOOTER //
// src/pages/home/operation.vue